// Pending group invite codes: someone who taps a /join/:code link while
// signed out gets ?invite=<CODE> on the signup and login CTAs. The code is
// stashed in localStorage because it must survive the email-confirmation
// redirect, which drops query params - the same reason guestClaim.js exists.
//
// Two deliberate differences from guestClaim.js:
//
//  1. This is NOT auto-redeemed on auth state change. Claiming your own guest
//     RSVP is unambiguous; joining a group is a membership action with plan
//     caps and a wrong-link failure mode, so it stays a confirmed action. The
//     code is consumed by the join UI (JoinByCodeForm / onboarding), which
//     shows a preview first.
//
//  2. localStorage is per-origin. The landing page runs on the apex and
//     signup runs on app.teesync.co.uk, so a stash written on the apex is
//     invisible to signup. The apex CTAs therefore carry the code in the URL;
//     this stash only has to bridge the confirmation redirect, which happens
//     entirely on the app origin.

const PENDING_KEY = 'teesync_pending_invite_code'

// Matches the alphabet used by generateInviteCode in groupService.js, which
// omits 0/1/I/O to keep codes readable when spoken aloud.
const CODE_RE = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{8}$/

export function isValidInviteCode(code) {
  return typeof code === 'string' && CODE_RE.test(code.toUpperCase().trim())
}

export function stashInviteCode(code) {
  if (!isValidInviteCode(code)) return
  try {
    localStorage.setItem(PENDING_KEY, code.toUpperCase().trim())
  } catch {
    // localStorage unavailable - the code just won't survive the redirect
  }
}

export function stashInviteCodeFromUrl() {
  try {
    const code = new URLSearchParams(window.location.search).get('invite')
    if (code) stashInviteCode(code)
  } catch {
    // As above
  }
}

export function getPendingInviteCode() {
  try {
    const code = localStorage.getItem(PENDING_KEY)
    return isValidInviteCode(code) ? code : null
  } catch {
    return null
  }
}

export function clearPendingInviteCode() {
  try {
    localStorage.removeItem(PENDING_KEY)
  } catch {
    // Nothing to do
  }
}
